import {ignoreCacheFormState} from './IgnoreCacheForm-State'
import {errorsList, errorsPresent, mergeServerValidationErrors} from '../../../../helpers/ErrorHelper'
import {isObject} from "../../../../helpers/DataHelper";

export default function ignoreCacheFormReducer(state = ignoreCacheFormState, action) {

    let {data} = {...state};
    let {validationErrors, name, value, mode, error, site_id, path} = action;
    switch (action.type) {

        case 'ON-IGNORE-CACHE-FORM-CHANGE':
            data.payload[name] = value;
            buildErrors();
            return {...state, data};

        case 'SET-IGNORE-CACHE-DATA-FOR-UPDATE':
            data= {
                payload: {
                    path: path.path
                },
                errors: [],
                errorsPresent: false,
                submitted: false,
                dispatchAPI: false,
                mode: `update`,
                message: ``
            }
            buildErrors();
            return {...state, data};

        case 'ON-DELETE-IGNORE-CACHE-FORM':
            data.payload[name] = value;
            buildErrors();
            return {...state, data};

        case 'ON-IGNORE-CACHE-FORM-MODE-CHANGE':
            data.mode = mode;
            buildErrors();
            return {...state, data};

        case 'SET-IGNORE-CACHE-ERROR':
            data.message = error;
            buildErrors();
            return {...state, data};

        case 'SET-SITE-ID':
            data.site_id = site_id;
            buildErrors();
            return {...state, data};

        case 'SET-DEFAULT-IGNORE-CACHE-FORM':
            data = {
                payload: {
                    path: "",
                },
                errors: [],
                errorsPresent: false,
                submitted: false,
                dispatchAPI: false,
                mode: `create`,
                message: ``
            };
            buildErrors();
            return {...state, data};

        case 'CANCEL-IGNORE-CACHE-FORM-DISPATCH':
            data.dispatchAPI = false;
            data.submitted = false;
            buildErrors();
            return {...state, data};

        case 'ON-IGNORE-CACHE-FORM-SUBMIT':
            data.submitted = true;
            buildErrors();
            if (!data.errorsPresent) data.dispatchAPI = true;
            return {...state, data};

        case 'IGNORE-CACHE-FORM-SERVER-VALIDATION-ERRORS':
            validationErrors && isObject(validationErrors) &&
            Object.keys(validationErrors).map(key =>
                data.errors[key] = [{message: ` - ${validationErrors[key][0]}`.slice(0, -1)}]
            );
            data.dispatchAPI = false;
            return {...state, data};

        default:
            return state
    }

    function buildErrors() {
        data.errors = errorsList(errors)
        data.errorsPresent = errorsPresent(errors)
    }

    function errors(field) {
        let {payload, submitted, validationErrors} = data;
        let errors = {};
        Object.keys(payload).map(key => errors[key] = []);

        if (submitted) {
            if (field === `path`) {
                if (!_(field)) newError(field, 0, `The path field is required`)
            }
        }

        errors = mergeServerValidationErrors(errors, validationErrors)

        return field ? errors[field] : errors

        function newError(field, step, message) {
            errors && errors[field].push({step, message})
        }

        function _(field) {
            return data.payload[field]
        }
    }
}